import { createFeatureSelector, createSelector } from '@ngrx/store';
import { CommunityItemSearchFilter } from 'src/app/models/community-item-search-filter';
import {
    CommunityFilterState,
    adapter,
    communityFilterFeatureKey,
} from './community-filter.reducer';

const { selectEntities } = adapter.getSelectors();

export const communityFilterState = createFeatureSelector<CommunityFilterState>(
    communityFilterFeatureKey
);

export const selectCommunityFilter = (id) =>
    createSelector(communityFilterState, selectEntities, (state) => {
        const entity = state.entities[id];
        return entity ? CommunityItemSearchFilter.fromDto(entity) : undefined;
    });
